"use strict";
/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelLoader = void 0;
const preset_1 = require("./preset");
const assets_1 = require("molstar/lib/mol-util/assets");
const transforms_1 = require("molstar/lib/mol-plugin-state/transforms");
const mol_state_1 = require("molstar/lib/mol-state");
const export_1 = require("molstar/lib/extensions/model-export/export");
class ModelLoader {
    async load(load, props, matrix, reprProvider, params) {
        const { fileOrUrl, format, isBinary } = load;
        const data = fileOrUrl instanceof File
            ? (await this.plugin.builders.data.readFile({ file: assets_1.Asset.File(fileOrUrl), isBinary, label: props === null || props === void 0 ? void 0 : props.dataLabel })).data
            : await this.plugin.builders.data.download({ url: fileOrUrl, isBinary, label: props === null || props === void 0 ? void 0 : props.dataLabel });
        return await this.handleTrajectory(data, format, props, matrix, reprProvider, params);
    }
    async parse(parse, props, matrix, reprProvider, params) {
        const { data, format } = parse;
        const _data = await this.plugin.builders.data.rawData({ data, label: props === null || props === void 0 ? void 0 : props.dataLabel });
        return await this.handleTrajectory(_data, format, props, matrix, reprProvider, params);
    }
    async handleTrajectory(data, format, props, matrix, reprProvider, params) {
        var _a, _b;
        const trajectory = await this.plugin.builders.structure.parseTrajectory(data, format);
        if (reprProvider) {
            return this.plugin.builders.structure.hierarchy.applyPreset(trajectory, reprProvider, params);
        }
        else {
            const selector = await this.plugin.builders.structure.hierarchy.applyPreset(trajectory, preset_1.RcsbPreset, {
                preset: props || { kind: 'standard', assemblyId: '' }
            });
            if (matrix && (selector === null || selector === void 0 ? void 0 : selector.structureProperties)) {
                const params = {
                    transform: {
                        name: 'matrix',
                        params: { data: matrix, transpose: false }
                    }
                };
                const b = this.plugin.state.data.build().to(selector.structureProperties)
                    .insert(transforms_1.StateTransforms.Model.TransformStructureConformation, params);
                await this.plugin.runTask(this.plugin.state.data.updateTree(b));
            }
            const structureCell = mol_state_1.StateObjectRef.resolveAndCheck(this.plugin.state.data, selector === null || selector === void 0 ? void 0 : selector.structure);
            ((_a = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _a === void 0 ? void 0 : _a.data) && export_1.ModelExport.setStructureName((_b = structureCell === null || structureCell === void 0 ? void 0 : structureCell.obj) === null || _b === void 0 ? void 0 : _b.data, (props === null || props === void 0 ? void 0 : props.dataLabel) || '');
            // TODO is this the best place for this functionality?
            if ((props === null || props === void 0 ? void 0 : props.kind) === 'motif') {
                const group = this.plugin.managers.structure.hierarchy.currentComponentGroups[0];
                this.plugin.managers.camera.focusSpheres(group, e => { var _a; return (_a = e.cell.obj) === null || _a === void 0 ? void 0 : _a.data.boundary.sphere; }, { durationMs: 0 });
            }
            return selector;
        }
    }
    constructor(plugin) {
        this.plugin = plugin;
    }
}
exports.ModelLoader = ModelLoader;
